import {fetchDataFromApi} from './apiHelper';

export const fetchStatFields = () => fetchDataFromApi('post', '/api/geoedge/main/getstat');
export const fetchDataFields = () => fetchDataFromApi('post', '/api/geoedge/main/getdata');
export const fetchPublisherFields = () => fetchDataFromApi('post', '/api/geoedge/main/getpublisher');
export const fetchDSPFields = () => fetchDataFromApi('post', '/api/geoedge/main/getdsp');

export const fetchIncidentsStatFields = () => fetchDataFromApi('post', '/api/geoedge/incidents/getstat');
export const fetchIncidentsDataFields = () => fetchDataFromApi('post', '/api/geoedge/incidents/getdata');
export const fetchIncidentsPublisherFields = () => fetchDataFromApi('post', '/api/geoedge/incidents/getpublisher');
export const fetchIncidentsDSPFields = () => fetchDataFromApi('post', '/api/geoedge/incidents/getdsp');